import React from 'react';
import {
  ModalInfoContainer,
  ModalInfoContent,
  ModalInfoHead,
  ModalInfoBody,
  ModalInfoBodyIcon,
  ModalInfoBodyLabel,
  ModalInfoBodyDescription
} from './styles';
import { IoClose } from 'react-icons/io5';
import colors from '../../assets/styles/colors';

const ModalInfo = ({ title, description, open, bodyIcon, setShowModal, backgroundIcon }) => {
  return (
    <ModalInfoContainer open={open}>
      <ModalInfoContent>
        <ModalInfoHead>
          <IoClose size={26} color={colors.textSecondary} onClick={() => setShowModal(false)} id="close-icon" />
        </ModalInfoHead>
        <ModalInfoBody>
          <ModalInfoBodyIcon backgroundIcon={backgroundIcon}>
            {bodyIcon}
          </ModalInfoBodyIcon>
          <ModalInfoBodyLabel>
            {title}
          </ModalInfoBodyLabel>
          {description && (
            <ModalInfoBodyDescription>
              {description}
            </ModalInfoBodyDescription>
          )}
        </ModalInfoBody>
      </ModalInfoContent>
    </ModalInfoContainer>
  )
}

export default ModalInfo
